import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import SliderItem from "./sliderItem";
import "swiper/css";
import "swiper/css/pagination";

const Slider = ({
  activeSlide,
  data,
  handleRevertedCard,
  revertCard,
  onSlideChange,
}) => {
  const pagination = {
    clickable: true,
    renderBullet: function (index, className) {
      const background = data[index]?.infos?.find(
        (el) => el.label === "color"
      )?.value;
      return (
        '<span class="' +
        className +
        '"  style="background:' +
        background +
        ';border-radius:100px" > </span>'
      );
    },
  };
  return (
    <Swiper
      centeredSlides={true}
      className="bank-swipper overflow-visible min-h-[400px] first:w-10/12  mx-0  "
      initialSlide={activeSlide}
      modules={[Pagination]}
      pagination={pagination}
      slidesPerView={"auto"}
      spaceBetween={30}
      onSlideChange={(e) => onSlideChange(e.activeIndex)}
    >
      {data?.map((item, index) => (
        <SwiperSlide className="  w-fit ">
          <SliderItem
            activeSlide={activeSlide}
            data={item}
            index={index}
            handleRevertedCard={handleRevertedCard}
            revertCard={revertCard}
          />
        </SwiperSlide>
      ))}

      {data.length === 1 && (
        <span
          className=" flex items-center p-5 w-10 h-10 border-4 border-white shadow-md mx-auto"
          style={{
            background: data[0]?.infos?.find((el) => el.label === "color")
              ?.value,
            borderRadius: "100px",
          }}
        ></span>
      )}
    </Swiper>
  );
};
export default Slider;
